module.exports = __webpack_public_path__ + "static/media/logo-haus-shiraz.a4120e85.svg";